import { useEffect, useState } from 'react';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';

import customAxios from '../../utils/customAxios';
import { GlobalVariables } from '../../globalVar';
import { getToast } from '../../utils/toastConfig';
import variables from '../../scss/_variables.scss';

export const UpdateRoleLicensesModal = ({
  roleConfig,
  showModal,
  setShowModal,
  refreshData,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [roleInfo, setRoleInfo] = useState({
    id: null,
    role_id: null,
    role_name: '',
    max_licenses: '',
    current_licenses: '',
    remaining_licenses: '',
  });

  useEffect(() => {
    if (showModal) {
      if (!roleConfig.id) {
        setRoleInfo(roleConfig);
      } else {
        fetchData();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);

  const fetchData = async () => {
    try {
      const endpoint = `${GlobalVariables.getURL()}licenses/roles/licenses/${
        roleConfig.id
      }`;
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });

      if (response.status === 204) {
        return;
      }

      setRoleInfo(response.data);
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({ status: 'error', title: error.response.data.message });
    }
  };

  const handleResetFields = () => {
    setRoleInfo({
      id: null,
      role_id: null,
      role_name: '',
      max_licenses: '',
      current_licenses: '',
      remaining_licenses: '',
    });
  };

  const handleClose = () => {
    setShowModal(false);
    handleResetFields();
    refreshData();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const endpoint = `${GlobalVariables.getURL()}licenses/roles/licenses/update/${
        roleInfo.id ? roleInfo.id : null
      }`;
      const response = await customAxios.patch(
        endpoint,
        {
          role_id: roleInfo.role_id,
          max_licenses: roleInfo.max_licenses,
        },
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        }
      );

      if (response.status === 200) {
        getToast({
          status: 'success',
          title: response.data.message,
        });
        handleClose();
      }
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({
        status: 'error',
        title: error.response.data.message,
        duration: 4,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={showModal} maxWidth='sm' fullWidth onClose={handleClose}>
      <DialogTitle>
        <Typography className='inventory-movmodal-title'>
          Actualizar licencias del rol:{' '}
          <span style={{ color: variables.secondaryRedDabi }}>
            {roleInfo.role_name}
          </span>
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label='close'
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 20,
          top: 20,
          width: 40,
          height: 40,
        }}
      >
        <FontAwesomeIcon icon={faTimes} />
      </IconButton>
      <DialogContent dividers>
        <form id='update-role-licenses-form' onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                disabled
                fullWidth
                label='Licencias en uso'
                placeholder='Licencias en uso...'
                value={roleInfo.current_licenses}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                disabled
                fullWidth
                label='Licencias restantes'
                placeholder='Licencias restantes...'
                value={roleInfo.remaining_licenses}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                type='number'
                fullWidth
                label='Número máximo de licencias'
                placeholder='Número máximo de licencias...'
                value={roleInfo.max_licenses}
                onChange={(e) =>
                  setRoleInfo({ ...roleInfo, max_licenses: e.target.value })
                }
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          form='update-role-licenses-form'
          type='submit'
          disabled={isLoading}
        >
          <Typography>Guardar</Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};
